<template>
  <div>
    <Header
      :history="history"
      :data="drawerData"
      @goBack="goBack"
      @close="close"
      @reload="loadData"
    />

    <transition name="fade">
      <div v-if="isSuccess">
        <h2 class="content__title get-height">{{ data.name || '-' }}</h2>

        <Tabs
          :data="drawerData"
          :drawerType="drawerType"
          :filters="filters"
          @change="change"
        />
      </div>
    </transition>

    <div
      v-if="isLoading"
      class="progress__wrapper text-xs-center py-5"
      :style="`height: ${contentHeight}px`"
    >
      <div class="progress">
        <v-progress-circular indeterminate color="accent" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { calcContentHeight, hasRole } from 'utils/functions'
import Header from './Header'
import Tabs from './Tabs'

export default {
  name: 'CostCenter',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    history: {
      type: Array,
      default: () => []
    },
    drawerType: {
      type: String,
      required: true
    },
    filters: {
      type: Object
    }
  },
  components: {
    Header,
    Tabs
  },
  computed: {
    ...mapState({
      costCenterTemporaryDisabled: ({ globalDrawer }) => globalDrawer.costCenterTemporaryDisabled
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      currentStatus: null,
      drawerData: {},
      rides: [],
      contentHeight: 'none'
    }
  },
  methods: {
    ...mapActions({
      setCostCenterTemporaryDisabled: 'globalDrawer/set'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload) {
      this.$emit('close', reload)
    },

    change (val) {
      this.$emit('change', val)
    },

    async loadData () {
      if (this.currentStatus === STATUS_IS_LOADING || !this.hasRole('costCenter', 'ROLE_GET_COSTCENTER_ID')) {
        this.currentStatus = STATUS_SUCCESS
        return
      }

      this.currentStatus = STATUS_IS_LOADING

      try {
        const { data: res } = await this.$apiService.getCostCenterById(this.data.id)

        this.drawerData = {
          costCenterId: this.data.id,
          ...res.data
        }

        this.setCostCenterTemporaryDisabled({
          costCenterTemporaryDisabled: res.data.temporaryDisabled
        })

        this.$emit('updateHistory', {
          drawerType: 'costCenter',
          data: this.data
        })

        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.loadData()
      }
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
    this.loadData()
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.progress__wrapper {
  position: relative;
}

.progress {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%)
}

.content__title {
  color: $gray-7;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 800;
  padding: 22px 24px;
  text-align: center;
}
</style>
